import { UserOptionLabel } from "components";
import { getFullName } from "helpers";
import { applicationListService } from "services";
import { FilterColumn } from "types";

const assignedToColumn = (): FilterColumn => ({
	name: "assignedTo",
	type: "select" as const,
	placeholder: "Assigned To",
	formatLabel: getFullName,
	getOptionLabel: UserOptionLabel,
	getOptionValue: option => option.id,
	loadOptions: async (search, prevOptions, { page }) => {
		try {
			const showInactive = true;

			let newUsers = await applicationListService.getAssignedUsers(
				search,
				page,
				showInactive,
			);
			const hasMore =
				prevOptions.length + newUsers.items.length < newUsers.count;

			return {
				options: newUsers.items,
				hasMore,
				additional: {
					page: page + 1,
				},
			};
		} catch {
			return { options: [] };
		}
	},
});

export default assignedToColumn;
